import { Component, DoCheck, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { animate, style, transition, trigger } from '@angular/animations';
import { AppConfig } from '../../../../../app-config';
import { AuthService } from '../../../../../core/domain/auth/services/auth.service';
import { AdminService } from '../../../../../core/domain/admin/services/admin.service';
import { PortalUserDto } from '../../../../../core/domain/admin/models/portalUserDto';
import { environment } from '@environments/environment';
import { Constants } from '@app/core/config';
import { VERSION } from '../../../../../../version';
import { LoggerService } from '../../../../../core/services/logger.service';
import { NavService } from '../../../../../core/services/nav.service';

@Component({
    selector: 'app-nav-right',
    templateUrl: './nav-right.component.html',
    styleUrls: ['./nav-right.component.scss'],
    providers: [NgbDropdownConfig],
    animations: [
        trigger('slideInOutLeft', [
            transition(':enter', [style({ transform: 'translateX(100%)' }), animate('300ms ease-in', style({ transform: 'translateX(0%)' }))]),
            transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(100%)' }))]),
        ]),
        trigger('slideInOutRight', [
            transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('300ms ease-in', style({ transform: 'translateX(0%)' }))]),
            transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(-100%)' }))]),
        ]),
    ],
})
export class NavRightComponent implements OnInit, DoCheck {
    public visibleUserList: boolean;
    public chatMessage: boolean;
    public friendId: boolean;
    public appConfig: any;
    public portalUser: PortalUserDto;
    public env = environment.env;
    public Constants = Constants;
    public currentAppVersion = environment.env == Constants.PROD ? VERSION.version : `${VERSION.version}.${environment.env}`;
    public currentEnv = environment.env != Constants.PROD ? environment.env.replace(/^./, (char) => char.toUpperCase()) : '';
    public buildVersion = VERSION.hash;

    constructor(
        config: NgbDropdownConfig,
        private authService: AuthService,
        private adminService: AdminService,
        private logger: LoggerService,
        private navService: NavService,
    ) {
        config.placement = 'bottom-right';
        this.visibleUserList = false;
        this.chatMessage = false;
        this.appConfig = AppConfig.config;
    }

    ngOnInit(): void {
        (async () => {
            try {
                //TODO: add try catch
                await this.adminService.getPortalUserLoggedinAsync();
                this.portalUser = this.adminService.portalUser;
                this.navService.setNavigation(this.portalUser);
            } catch (error) {
                this.logger.error(error);
            }
        })();
    }

    onChatToggle(friend_id): void {
        this.friendId = friend_id;
        this.chatMessage = !this.chatMessage;
    }

    ngDoCheck(): void {
        if (document.querySelector('body').classList.contains('rtl')) {
            this.appConfig['rtlLayout'] = true;
        } else {
            this.appConfig['rtlLayout'] = false;
        }
    }

    onLogOut(): void {
        this.authService.logout();
    }
}
